module.exports = __webpack_public_path__ + "static/media/44561816_2199904483418064_1555929946826735616_o-thumb.eeb215db.jpg";